/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { FSBTable } from 'components/common/FSBTable';
import {
  ORDER_BY_VENDOR_ID,
  ORDER_BY_VENDOR_ID_SUBSCRIPTION,
} from 'utils/CommonGraphQL';
import { orderColumns, showSequenceNumber } from 'utils/constants';
import { cloneDeep, isEmpty } from 'lodash';
import Loader from 'components/common/Loader';

const VendorOrderPurchaseTable = () => {
  const { selectedVendor } = useSelector((state) => state.vendorDetailsReducer);
  const [filters, setFilters] = useState({
    filter: [
      {
        key: 'buyer',
        value: selectedVendor?.id,
        type: 'INT',
        op: 'EQ',
      },
    ],
    pageNo: 1,
    pageSize: 10,

    sortCol: 'createdAt',

    sortDirection: 'DESC',
  });
  const { data, loading, error, subscribeToMore } = useQuery(
    ORDER_BY_VENDOR_ID,
    {
      variables: filters,
      fetchPolicy: 'network-only',
    },
  );

  const findIndexOfItem = (item) => {
    return orderColumns.findIndex((itm) => itm.accessorKey === item);
  };
  orderColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);

  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo: data?.orders?.totalCount < pageSize ? 1 : pageNo,
      pageSize,
    });
  };
  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: ORDER_BY_VENDOR_ID_SUBSCRIPTION,
      variables: { ...filters },
      updateQuery: (prev, { subscriptionData }) => {
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (!subscriptionData.data?.orders?.order?.id) return prev;
        const newData = cloneDeep(prev);
        const indexFound = newData.orders.orders.findIndex(
          (val) => val.id === subscriptionData.data?.orders?.order?.id,
        );
        if (subscriptionData.data.orders.action === 'CREATED') {
          const newOrder = subscriptionData.data.orders.order;
          const updatedOrders = [newOrder, ...newData.orders.orders];

          const newTotalCount = prev.orders.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.orders = {
            ...newData.orders,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            orders: updatedOrders,
          };
        }
        if (subscriptionData.data.orders.action === 'UPDATED') {
          newData.orders.orders[indexFound] =
            subscriptionData.data.orders.order;
        }

        if (subscriptionData.data.orders.action === 'DELETED') {
          const { id } = subscriptionData.data.orders.order; // ID of the order to remove
          const prevOrders = prev.orders.orders;

          const updatedOrders = prevOrders.filter((val) => val.id !== id);

          const newTotalCount = prev.orders.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedOrdersData = {
            ...newData.orders,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            orders: updatedOrders,
          };

          newData.orders = updatedOrdersData;
        }
        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //   const updatedFilter = [...filters.filter]; // Clone the filter array
  //   const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //   updatedFirstFilter.value = searchString;
  //   updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //   // return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //   refetch({ ...filters, filter: updatedFilter });
  // }, [searchString]);

  // const onGlobalSearch = (str) => {
  //   if (str) {
  //     setFilters((prevFilter) => {
  //       const updatedFilter = [...prevFilter.filter]; // Clone the filter array
  //       const updatedFirstFilter = { ...updatedFilter[0] }; // Clone the 0th filter object
  //       updatedFirstFilter.value = str;
  //       updatedFilter[0] = updatedFirstFilter; // Replace the 0th filter with the updated one
  //       return { ...prevFilter, filter: updatedFilter }; // Update the filter property in the state
  //     });
  //   }
  // };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.orders?.orders) return 'Orders not available';

  return (
    <FSBTable
      data={(data && data?.orders?.orders) || []}
      totalCount={(data && data?.orders?.totalCount) || 0}
      totalPages={(data && data?.orders?.totalPages) || 0}
      columns={orderColumns}
      currentPageNo={filters.pageNo}
      pageSize={filters.pageSize}
      keyField="id"
      showSearch={false}
      showFilters={false}
      showDelete={false}
      showPagination
      remote
      striped={false}
      hover={false}
      bordered={false}
      wrapperClass="table-responsive word-break"
      handlePageChange={handlePageChange}
      // globalSearchStr={filters.filter[0].value}
      // onGlobalSearch={onGlobalSearch}
      onSortChange={onSortChange}
      sorting={sortBy}
      searchPlaceholder="Search"
    />
  );
};
export default VendorOrderPurchaseTable;
